import { useEffect, useState } from "react";
import axios from "axios";
import Lenis from "lenis";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { ShowcaseStrip } from "@/components/ShowcaseStrip";
import { RolesSection } from "@/components/RolesSection";
import { PayCalculator } from "@/components/PayCalculator";
import { WorkflowSection } from "@/components/WorkflowSection";
import { AboutSection } from "@/components/AboutSection";
import { ApplyForm } from "@/components/ApplyForm";
import { Footer } from "@/components/Footer";
import { RoleDetailModal } from "@/components/RoleDetailModal";
import { ChatWidget } from "@/components/ChatWidget";
import { Reveal, Chapter } from "@/components/motion/Motion";
import { API } from "@/constants/roles";

export default function Home() {
  const [selectedRole, setSelectedRole] = useState("Standard Animator");
  const [modalRole, setModalRole] = useState(null);
  const [roleStatus, setRoleStatus] = useState({});

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis; // lets overlays (e.g. the showcase viewer) freeze smooth scroll
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
      delete window.__lenis;
    };
  }, []);

  useEffect(() => {
    axios
      .get(`${API}/roles`)
      .then((r) => {
        const map = {};
        r.data.forEach((x) => {
          map[x.role] = x.open;
        });
        setRoleStatus(map);
      })
      .catch(() => {});
  }, []);

  const handleApply = (role) => {
    setModalRole(null);
    setSelectedRole(role);
    setTimeout(() => {
      document.getElementById("apply")?.scrollIntoView({ behavior: "smooth" });
    }, 50);
  };

  return (
    <div data-testid="home-page" className="relative">
      <div className="noise-overlay" aria-hidden="true" />
      <Navbar />
      <Hero />
      <EditorialMarquee />
      <ShowcaseStrip />
      <Chapter index="01" label="Open roles">
        <Reveal>
          <RolesSection onViewDetails={setModalRole} roleStatus={roleStatus} />
        </Reveal>
      </Chapter>
      <Chapter index="02" label="The pay">
        <Reveal>
          <PayCalculator />
        </Reveal>
      </Chapter>
      <Chapter index="03" label="How production works">
        <Reveal>
          <WorkflowSection />
        </Reveal>
      </Chapter>
      <Chapter index="04" label="The channel">
        <Reveal>
          <AboutSection />
        </Reveal>
      </Chapter>
      <Chapter index="05" label="Apply">
        <Reveal>
          <ApplyForm key={selectedRole} selectedRole={selectedRole} roleStatus={roleStatus} />
        </Reveal>
      </Chapter>
      <Footer />
      <RoleDetailModal
        roleName={modalRole}
        isClosed={modalRole ? roleStatus[modalRole] === false : false}
        onClose={() => setModalRole(null)}
        onApply={handleApply}
      />
      <ChatWidget />
    </div>
  );
}
